<div [formGroup]="group" class="price-fs">
    <div class="col-to-row-s-tb" *ngIf="config.title">
        <div class="col-md-12">
            <h2 class="form-title">{{ config.title }}</h2>
        </div>
    </div>
    <div class="col-to-row-s-tb ctn-top">
        <div class="rm-marge-right flex-2">
            <multiselect-field [placeholder]="placeholder"
                [group]="group" controlName="keyword"
                [options]="options"></multiselect-field>
        </div>
    </div>
</div>
